import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import nl from 'vuetify/es5/locale/nl';

Vue.use(Vuetify);

export default new Vuetify({
  // iconfont: 'fa',
  lang: {
    locales: { nl },
    current: 'nl',
  },
  theme: {
    themes: {
      light: {
        primary: '#F7A611',
      },
    },
  },
});
